import UpdateBiddingTypeModal from "./UpdateBiddingTypeModal";

export default UpdateBiddingTypeModal;